import Model from '@/models/Model.js';

export default class WidgetTemplate extends Model {
    static entity = 'widget_templates';

    static modelName = 'WidgetTemplate';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            type: this.attr(null),
            description: this.attr(null),
            color: this.attr(null),
            layout_x: this.attr(null),
            layout_y: this.attr(null),
            layout_width: this.attr(null),
            layout_height: this.attr(null),
            layout_name: this.attr(null),

            ...super.fields(),
        };
    }
}
